import { DomHelper } from '@bryntum/schedulerpro';
import React, { useCallback, useRef } from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { PageLoading } from 'components/atoms/loading';
import { SchedulerReference } from '../types';

interface Props {
  schedulerRef: SchedulerReference;
}
interface Result {
  showLoading: () => void;
  hideLoading: () => void;
}
export const useLoadingRenderer = ({ schedulerRef }: Props): Result => {
  const maskRef = useRef<ReturnType<typeof DomHelper.createElement>>();

  const showMask = useCallback(() => {
    if (maskRef.current != null) {
      return;
    }
    const maskDiv = DomHelper.createElement({
      tag: 'div',
      className: 'custom-loader',
      children: [
        {
          html: renderToStaticMarkup(<PageLoading css />),
        },
      ],
    });

    if (schedulerRef.current?.instance.element) {
      DomHelper.append(schedulerRef.current?.instance.element, maskDiv);
    }
    maskRef.current = maskDiv;
  }, [schedulerRef]);
  const hideMask = useCallback(() => {
    if (schedulerRef.current != null) {
      DomHelper.removeEachSelector(
        schedulerRef.current.instance.element,
        '.custom-loader',
      );
    }
    maskRef.current = undefined;
  }, [schedulerRef]);

  return {
    showLoading: showMask,
    hideLoading: hideMask,
  };
};
